import React from "react"
import styled from "styled-components"
import { desktop, mobile, tablet } from "components/_blueprint/Layout"
import { RiskReportData } from "hooks/useRiskReport"

export const ApplicantPills = ({ riskReport }: { riskReport: RiskReportData }) => (
  <Container>
    {riskReport.riskIndividual.map((ri, index) => (
      <Pill key={index}>
        <TextStrong>{ri.name}</TextStrong>
        <TextLight>{ri.sex}</TextLight>
        <TextLight>Aged {ri.age}</TextLight>
        <TextLight>Retiring {ri.retirementAge}</TextLight>
        <TextLight>{ri.smokerStatus === "Yes" ? "Does Smoke" : "Doesn't Smoke"}</TextLight>
      </Pill>
    ))}
  </Container>
)

const Container = styled.div({
  display: "flex",
  justifyContent: "center",

  margin: "0 auto",

  [mobile]: {
    flexDirection: "row",
    gap: "16px",
    padding: "16px 0",
  },
  [tablet]: {
    flexDirection: "column",
    gap: "24px",
    padding: "24px 0",
  },
  [desktop]: {
    flexDirection: "row",
    gap: "48px",
    padding: "48px 0",
  },
})

const Pill = styled.div({
  display: "flex",
  gap: "32px",
  padding: "16px 32px",
  background: "#F8F9FC",
  justifyContent: "space-between",
  textAlign: "center",

  [mobile]: {
    flexDirection: "column",
    borderRadius: "50px",
  },
  [tablet]: {
    flexDirection: "row",
    borderRadius: "25px",
  },
  [desktop]: {
    flexDirection: "row",
    borderRadius: "25px",
  },
})

const TextStrong = styled.span({
  margin: "auto",
  fontWeight: 600,
  lineHeight: "180%",
})

const TextLight = styled.span({
  margin: "auto",
  lineHeight: "180%",
  color: "#6E717C",
})
